import { render } from "./Products.vue?vue&type=template&id=10e82620&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=10e82620&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10e82620"

export default script